<template>
   <div class="s-top-bar">
      <div >
        <em class="s-icon s-icon-list" @click="showCategory = !showCategory"></em>
        <div class="s-category-wrap" v-show="showCategory">
          <div class="s-category">
            <ul class="s-category-list">
              <li v-for="(item,index) in categoryList"
                :key="index"
                @click="onSearch(item)"
                :class="{'is-selected':item === category}">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="s-search-wrap">
        <input type="text" class="s-top-bar_search" placeholder="搜索昵称、抖音ID"
          :value="value"
          ref="search"
          @change="onSearch()">
        <button class="s-search-button" @click="onSearch()">搜索</button>
      </div>
      <router-link :to="{name:'home'}" v-if="!hideHome">
        <em class="s-icon s-icon-home"></em>
      </router-link>
      <router-link :to="{name:'my'}">
        <em class="s-icon s-icon-my"></em>
      </router-link>
    </div>
</template>

<script>
export default {
  name: 'topBar',
  props: {
    value: {
      type: String
    },
    category: {
      type: String
    }
  },
  data () {
    return {
      categoryList: [
        '游戏类',
        '美妆类',
        '运动类',
        '潮人类',
        '音乐类',
        '跳舞类',
        '演绎类',
        '段子类',
        '萌宠类',
        '美食类',
        '生活类',
        '技术类'
      ],
      showCategory: false,
      hideHome: false
    }
  },
  methods: {
    onSearch (category) {
      this.showCategory = false
      this.$router.push({
        name: 'infoList',
        query: {
          ...this.$route.query,
          keyword: this.$refs.search.value,
          category
          // douyinId : this.$refs.search.value
        }
      })
    }
  },
  mounted(){
    this.hideHome = this.$route.query.home === "0"
  }
}
</script>

<style scoped lang="less">
.s-top-bar {
  height: 60px;
  padding: 12px 50px;
  background: #161823;
  position: relative;
  padding-right: 80px;

  &_search {
    height: 36px;
    border-radius: 36px;
    background: #383942;
    font-size: 15px;
    border: none;
    padding-left: 15px;
    color: #fff;
    outline: none;
    width: 100%;
    &:focus{
      & + .s-search-button {
        display: block;
      }
    }
  }
}
.s-icon{
  display: inline-block;
  background-size: contain;
  vertical-align: middle;
  position: absolute;
  top: 19px;
}
.s-search-wrap{
  position: relative;
}
.s-search-button {
  position: absolute;
  right: 10px;
  color: #fff;
  top: 7px;
  font-size: 13px;
  border:none;
  background: transparent;
  //display: none;
}
.s-icon-list {
  background-image: url(../../assets/images/list.png);
  width: 21px;
  height: 18px;
  left: 12px;
}

.s-icon-home {
  background-image: url(../../assets/images/home.png);
  width: 24px;
  height: 25px;
  right: 45px;
}
.s-icon-my {
  background-image: url(../../assets/images/my.png);
  width: 19px;
  height: 25px;
  right: 12px;
}

.s-category{
  position: absolute;
  z-index: 3;
  left: -45px;
  top: 41px;
  border-radius: 6px;
  background: #fff;
  width: 255px;
  padding: 15px 0 0 15px;
  &-list{
    &>li{
      width: 105px;
      background-color: #F1F1F2;
      float: left;
      line-height: 40px;
      text-align: center;
      margin-bottom: 15px;
      height: 40px;
      margin-right: 15px;
      border-radius: 4px;
      &.is-selected{
        background: rgb(103, 88, 234);
        color:#fff;
      }
    }
  }
  &-wrap{
    position: relative;
    &:before{
      content: "";
      border:8px solid transparent;
      position: absolute;
      border-bottom-color:#fff;
      top:25px;
      left:-35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topBar/index.vue